export const types = Object.freeze({
    RESET_TRIP_ANALYZER: 'tripAnalyzer/RESET',
    SET_QUERY: 'tripAnalyzer/SET_QUERY',
    OPEN_TSP_PANEL: 'tripAnalyzer/OPEN_TSP_PANEL',
    CLOSE_TSP_PANEL: 'tripAnalyzer/CLOSE_TSP_PANEL',

    SERVICE_DATES_REQUEST: 'tripAnalyzer/SERVICE_DATES_REQUEST',
    SERVICE_DATES_SUCCESS: 'tripAnalyzer/SERVICE_DATES_SUCCESS',
    SERVICE_DATES_ERROR: 'tripAnalyzer/SERVICE_DATES_ERROR',

    CATALOG_REQUEST: 'tripAnalyzer/CATALOG_REQUEST',
    CATALOG_SUCCESS: 'tripAnalyzer/CATALOG_SUCCESS',
    CATALOG_ERROR: 'tripAnalyzer/CATALOG_ERROR',

    COLUMNS_SUCCESS: 'tripAnalyzer/COLUMNS_SUCCESS',

    TIMELINE_REQUEST: 'tripAnalyzer/TIMELINE_REQUEST',
    TIMELINE_SUCCESS: 'tripAnalyzer/TIMELINE_SUCCESS',
    TIMELINE_ERROR: 'tripAnalyzer/TIMELINE_ERROR',

    SEARCH_PREVIEW_REQUEST: 'tripAnalyzer/SEARCH_PREVIEW_REQUEST',
    SEARCH_PREVIEW_SUCCESS: 'tripAnalyzer/SEARCH_PREVIEW_SUCCESS',
    SEARCH_PREVIEW_ERROR: 'tripAnalyzer/SEARCH_PREVIEW_ERROR',

    CORRIDOR_REQUEST: 'tripAnalyzer/CORRIDOR_REQUEST',
    CORRIDOR_SUCCESS: 'tripAnalyzer/CORRIDOR_SUCCESS',
    CORRIDOR_ERROR: 'tripAnalyzer/CORRIDOR_ERROR',

    TSP_EVENTS_REQUEST: 'tripAnalyzer/TSP_EVENTS_REQUEST',
    TSP_EVENTS_SUCCESS: 'tripAnalyzer/TSP_EVENTS_SUCCESS',
    TSP_EVENTS_ERROR: 'tripAnalyzer/TSP_EVENTS_ERROR',
});

export const catalogKinds = Object.freeze({
    ROUTES: 'routes',
    DIRECTIONS: 'directions',
    TRIPS: 'trips',
});
